console.log('js/modal-when-leaving.js -> v0.1.0');
$(function() {
	function addEvent(obj, evt, fn) {
		if (obj.addEventListener) {
			obj.addEventListener(evt, fn, false);
		}
		else if (obj.attachEvent) {
			obj.attachEvent("on" + evt, fn);
		}
	}

	if ((isIndexPage || isTopicPage) && !isSubscriber) {
		addEvent(window, 'load', e => {
			addEvent(document, "mouseout", e => {
				e = e ? e : window.event;

				var showModal = $("body").data("showModalWhenLeavingWindow") == 1;

				var from = e.relatedTarget || e.toElement;

				if (showModal && (!from || from.nodeName == "HTML") && e.pageY < jQuery(window).scrollTop()) {
					if ($('#subscribe_modal').length) {
						if (typeof $('#subscribe_modal').modal === 'function') {
							$('#subscribe_modal').modal()
						} else {
							console.warn('The "_subscribe_modal" element does not have a "modal" method.')
							gae('jsWarning', 'noModal-methodNotFound')
						}
					} else {
						console.warn('No "subscribe_modal" element found.')
						gae('jsWarning', 'noModal-elementNotFound')
					}
				}
			});
		});
	}

	let isNewsLetterSubscribe = document.querySelector('#newsletter_subscribe');
	let hasUserSubscribedParam = '';
	if(isNewsLetterSubscribe != null) {
		hasUserSubscribedParam = isNewsLetterSubscribe.value
	}

	$('#subscribe_modal').on('hide', function () {
		$.post( "/disable_modal", function( data ) { });
		$("body").data("showModalWhenLeavingWindow", 0);
	});

	if(typeof(isIndexPage) != "undefined" && typeof(isTopicPage) != "undefined"){

		if ((isIndexPage || isTopicPage) && window.localStorageStatus === true && !isSubscriber && ($("body").data("showModalWhenLeavingWindow") == 0)) {
			if(hasUserSubscribedParam == 'true') {
				if(localStorage.getItem('newletterSubscription') == null) {
					$('#subscribe_modal').modal('show');
					localStorage.setItem('newletterSubscription', true);
				}
			}
			else {
			setInterval(function(){
				try {

					if(localStorage.getItem("corner") == null){
						localStorage.setItem("corner",0);

					}else if((Math.floor(Date.now() / 1000) - Number(localStorage.getItem("corner"))) > (60*5)){

						if((window.matchMedia('all and (min-width: 768px)').matches)) {

							var subscribeCorner = $('.js-subscribe-corner');
							var subscribeCornerButton = $('.js-subscribe-signup');
							var subscribeCornerClose = $('.js-subscribe-corner-close');

							clearInterval(cornerInterval);
							var cornerInterval = setInterval(function(){
								if($(document).scrollTop() > 1000){

									localStorage.setItem("corner",(Math.floor(Date.now() / 1000)));
									clearInterval(cornerInterval);

									setTimeout(function(){
										subscribeCorner.removeClass('hide');
									},500);

								};
							},1000);

							subscribeCornerButton.click(function(){
								$('#subscribe_modal').modal('show');
								subscribeCorner.addClass('hide');
							});

							subscribeCornerClose.click(function(){
								subscribeCorner.addClass('hide');
								localStorage.setItem("corner",(Math.floor(Date.now() / 1000) + 60*10));
							});
						};
					};
				} catch (error) {
					// Some browser states, e.g., Safari in private mode, reject acess to localStorage, resulting in an error.
					if(error.name === 'SecurityError') {
						console.warn('Could not save to localStorage due to security settings.'),
						gae('jsWarning', 'localStorage-SecurityError')
					} else {
						throw error
					}
				}
			},1000);
		};
	}
	};

});
